// extracted by mini-css-extract-plugin
export var closeBtn = "diagnostics-panel-module--closeBtn--aa889";
export var crtSettle = "diagnostics-panel-module--crt-settle--972ff";
export var decoRays = "diagnostics-panel-module--deco-rays--75cd0";
export var decoShimmer = "diagnostics-panel-module--deco-shimmer--34195";
export var empty = "diagnostics-panel-module--empty--4df4e";
export var eventName = "diagnostics-panel-module--eventName--6b212";
export var eventPayload = "diagnostics-panel-module--eventPayload--3ebcb";
export var eventSummary = "diagnostics-panel-module--eventSummary--f8670";
export var eventTime = "diagnostics-panel-module--eventTime--0f4f5";
export var flagKey = "diagnostics-panel-module--flagKey--4b396";
export var flagValue = "diagnostics-panel-module--flagValue--f5e28";
export var flagVariation = "diagnostics-panel-module--flagVariation--c74ee";
export var homeTheme = "diagnostics-panel-module--homeTheme--855b9";
export var list = "diagnostics-panel-module--list--82484";
export var listItem = "diagnostics-panel-module--listItem--5edcb";
export var panel = "diagnostics-panel-module--panel--801c2";
export var panelBody = "diagnostics-panel-module--panelBody--4d99f";
export var panelHeader = "diagnostics-panel-module--panelHeader--fcb27";
export var panelTitle = "diagnostics-panel-module--panelTitle--e7375";
export var root = "diagnostics-panel-module--root--442cc";
export var scanlines = "diagnostics-panel-module--scanlines--6e500";
export var sectionTitle = "diagnostics-panel-module--sectionTitle--c6bae";
export var showcaseTheme = "diagnostics-panel-module--showcaseTheme--3e35f";
export var signalBlink = "diagnostics-panel-module--signal-blink--a21bc";
export var status = "diagnostics-panel-module--status--61b8e";
export var toggle = "diagnostics-panel-module--toggle--e3a7b";